import classes from './brand-loader.module.css';

const perforations = [-22, 4, 30, 56, 82, 108];

export const BrandLoader = ({
  size = 64,
  active = true,
  className,
}: {
  size?: number;
  active?: boolean;
  className?: string;
}) => (
  <svg
    className={`${classes.logo} ${className ?? ''}`}
    style={{ width: size, height: size }}
    data-brand-loader
    data-paused={!active || undefined}
    viewBox="0 0 128 128"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    {[5, 111].map((x, index) => (
      <svg key={x} x={x} y="13" width="12" height="104" viewBox="0 0 12 104" overflow="hidden">
        <g className={index === 0 ? classes.leftStrip : classes.rightStrip}>
          {perforations.map((y) => (
            <rect key={y} y={y} width="12" height="9" rx="2" />
          ))}
        </g>
      </svg>
    ))}
    <path
      d="M240 0 383 252H387L666 750H944L518 0ZM376 91 -1 750H283L562 256Z"
      transform="translate(30.5 91) scale(0.071 -0.071)"
    />
  </svg>
);
